export default function StrokeCounts (){
    const strokeCounts = {
        'A':  {
          'straight': 3,
          'curve': 0
        },
        'B':  {
          'straight': 1,
          'curve': 2
        },
        'C':  {
          'straight': 0,
          'curve': 1
        },
        'D':  {
          'straight': 1,
          'curve': 1
        },
        'E':  {
          'straight': 4,
          'curve': 0
        },
        'F':  {
          'straight': 3,
          'curve': 0
        },
        'G':  {
          'straight': 2,
          'curve': 1
        },
        'H':  {
          'straight': 3,
          'curve': 0
        },
        'I':  {
          'straight': 3,
          'curve': 0
        },
        'J':  {
          'straight': 0,
          'curve': 1
        },
        'K':  {
          'straight': 3,
          'curve': 0
        },
        'L':  {
          'straight': 2,
          'curve': 0
        },
        'M':  {
          'straight': 4,
          'curve': 0
        },
        'N':  {
          'straight': 3,
          'curve': 0
        },
        'O':  {
          'straight': 0,
          'curve': 1
        },
        'P':  {
          'straight': 1,
          'curve': 1
        },
        'Q':  {
          'straight': 1,
          'curve': 1
        },
        'R':  {
          'straight': 2,
          'curve': 1
        },
        'S':  {
          'straight': 0,
          'curve': 1
        },
        'T':  {
          'straight': 2,
          'curve': 0
        },
        'U':  {
          'straight': 0,
          'curve': 1
        },
        'V':  {
          'straight': 2,
          'curve': 0
        },
        'W':  {
          'straight': 4,
          'curve': 0
        },
        'X':  {
          'straight': 2,
          'curve': 0
        },
        'Y':  {
          'straight': 3,
          'curve': 0
        },
        'Z':  {
          'straight': 3,
          'curve': 0
        }     
      }
      return strokeCounts;
}

